import { createContext, useReducer, useState } from "react";

export const MensajeCont=createContext<any>("");

const reducer=(state:any,action:any):string=>
{
    return action.input;
}

export const MensajeGeneral=({children}:any)=>
{
    const [MensajeContex,dispatch]=useReducer(reducer,"");

    const [DatosGoogle,SetDatosGoogle]=useState<any>()
    const [Redireccionamiento,SetRedireccionamiento]=useState<any>("")

    const ActualizacionMensaje=(number:string)=>
    {
        dispatch({input:number})
    }

    return (
        <MensajeCont.Provider value={{MensajeContex,ActualizacionMensaje,DatosGoogle,SetDatosGoogle,Redireccionamiento,SetRedireccionamiento}}>
            {children}
        </MensajeCont.Provider>
    )
}